import React, { useState } from 'react';
import './Navbar.css';

const navItems: string[] = [
  'Ana Sayfa',
  'Sınıflar',
  'Belirli Gün ve Haftalar',
  'Öğretmen Evrakları',
  'Ödevmatik',
  'Etkinlikler',
  'Giriş Yap',
  'Kayıt Ol',
];

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  function handleToggleMenu() {
    setIsMenuOpen((prev) => !prev);
  }

  function handleMenuItemClick() {
    setIsMenuOpen(false);
  }

  return (
    <header className="new-site-navbar-shell">
      <div className="new-site-navbar-track">
        <div className="new-site-navbar-head-row">
          <div className="new-site-navbar-logo" aria-hidden="true">
            Logo
          </div>

          <button
            type="button"
            className="new-site-navbar-toggle"
            aria-expanded={isMenuOpen}
            aria-controls="new-site-navbar-menu"
            aria-label="Menüyü aç veya kapat"
            onClick={handleToggleMenu}
          >
            <span className="new-site-navbar-toggle-line" />
            <span className="new-site-navbar-toggle-line" />
            <span className="new-site-navbar-toggle-line" />
          </button>
        </div>

        <nav
          id="new-site-navbar-menu"
          className={
            isMenuOpen
              ? 'new-site-navbar-menu new-site-navbar-menu-open'
              : 'new-site-navbar-menu'
          }
          aria-label="Yeni site ana menüsü"
        >
          <ul className="new-site-navbar-list">
            {navItems.map((item) => {
              const isAuthItem = item === 'Giriş Yap' || item === 'Kayıt Ol';

              return (
                <li key={item} className="new-site-navbar-list-item">
                  <button
                    type="button"
                    className={
                      isAuthItem
                        ? 'new-site-navbar-pill-button new-site-navbar-pill-auth'
                        : 'new-site-navbar-pill-button'
                    }
                    onClick={handleMenuItemClick}
                  >
                    {item}
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;